import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';

@Directive({
    selector: '[dataAnalyticsName]',
    standalone: false
})

export class PiwikDirective implements OnInit {
  @Input() dataAnalyticsName: string;
  constructor(private readonly renderer: Renderer2, private readonly el: ElementRef) {}

  ngOnInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'data-analytics-name', this.dataAnalyticsName);
  }
}
